<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="user"/>&nbsp;Registrar Anexo
        </div>
      </div>
      <div class="card-body pb-5">
        <!--begin: Details -->
          <div class="row mt-4">
            <div class="col-sm-6">
              <h4 class="font-info">Datos Generales</h4>
            </div>
          </div>
          <sys-form :inputs="attachment_details" v-if="loaded"/>
        <!--end: Details -->
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.push({ name: 'attachments' })">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-success" :class="{ 'disabled': form.isSaving }" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import attachmentsService from '@/services/attachments'
import investorsService from '@/services/investors'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'
import moment from 'moment'

export default {
  name: 'AttachmentCreate',

  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      loaded: false,
      attachment_details: {
        investor_id: {
          name: 'Acreedor',
          value: '',
          type: 'select',
          options: [],
          size: 12,
          validate: 'required'
        },
        contract_id: {
          name: 'Contrato',
          value: '',
          type: 'select',
          options: [],
          size: 6,
          validate: 'required'
        },
        parent_id: {
          name: 'Anexo',
          value: '',
          type: 'select',
          options: [],
          size: 6
        },
        cut_day: {
          name: 'Día de corte',
          hint: 'Día de corte',
          value: '',
          type: 'select',
          options: [],
          disabled: true
        },
        interest_rate: {
          name: 'Tasa de Interés',
          hint: '5%',
          value: '',
          min: 0,
          max: 100,
          type: 'number',
          disabled: true
        },
        frequency: {
          name: 'Frecuencia de Pago',
          type: 'select',
          options: [],
          disabled: true
        },
        date_start: {
          name: 'Fecha de Registro',
          hint: 'dd/mm/aaaa',
          value: '',
          type: 'date'
        },
        date_init: {
          name: 'Fecha de Inicio',
          hint: 'dd/mm/aaaa',
          value: '',
          type: 'date',
          validate: 'required'
        },
        date_expire: {
          name: 'Fecha de Expiración',
          hint: 'dd/mm/aaaa',
          value: '',
          type: 'date',
          validate: 'required'
        },
        amount: {
          name: 'Monto del Anexo',
          hint: 'Monto del Anexo',
          value: '',
          type: 'number',
          min: 0,
          validate: 'required'
        },
        type: {
          name: 'Tipo de Anexo',
          hint: 'Tipo de Movimiento',
          type: 'select',
          options: [{ value: 'Inicial', text: 'Inicial', selected: true }, { value: 'Incremento', text: 'Incremento' }, { value: 'Retiro', text: 'Retiro' }, { value: 'Renovacion', text: 'Renovacion' }]
        },
        state: {
          name: 'Estatus de Anexo',
          hint: 'Estatus',
          type: 'select',
          options: [{ value: 'Registrado', text: 'Registrado', selected: true }, { value: 'En firma', text: 'En firma' }, { value: 'En archivo', text: 'En archivo' }, { value: 'Pagaré Cancelado', text: 'Pagaré Cancelado' }]
        }
      },
      contracts: {}
    }
  },

  created: function () {
    this.loaded = false

    this.attachment_details.cut_day.value = { value: '', text: 'Seleccione el día de corte' }
    this.attachment_details.frequency.value = { value: '', text: 'Seleccione la frecuencia de pago' }

    investorsService.withContracts().then(res => {
      this.attachment_details.investor_id.options = res.map(investor => {
        if (investor.type == 'Moral') investor.fullname = investor.corporate_name
        return { value: investor.id, text: investor.fullname }
      })

      this.attachment_details.investor_id.value = { value: null, text: 'Seleccione un Acreedor' }
      this.attachment_details.contract_id.value = { value: null, text: 'Seleccione un Acreedor Primero' }
      this.attachment_details.parent_id.value = { value: null, text: 'Seleccione un Anexo' }
      this.loaded = true
    })
  },

  methods: {
    saveForm: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let body = this.processForm(this.attachment_details)
          let service = attachmentsService.post(body)

          this.sendForm(service).then(res => {
            this.$router.push({ name: 'attachments', props: { attachment: res } })
          }).catch(err => {
            console.log(JSON.stringify(err))
          })
        }
      })
    }
  },

  watch: {
    'attachment_details.investor_id.value': function (newInvestor, oldInvestor) {
      this.attachment_details.contract_id.value = { value: '', text: 'Seleccione un Contrato' }

      if (!newInvestor.value) return

      investorsService.contracts(newInvestor.value).then(res => {
        this.attachment_details.contract_id.options = res.map(contract => {
          return {
            value: contract.id,
            text: contract.folio,
            cut_day: contract.cut_day,
            interest_rate: contract.interest_rate,
            frequency: contract.frequency_name
          }
        })
      })
    },

    'attachment_details.contract_id.value': function (newContract, oldContract) {
      if (!newContract.value) {
        this.attachment_details.cut_day.value = ''
        this.attachment_details.interest_rate.value = ''
        this.attachment_details.frequency.value = ''
        return
      }

      let id = newContract.value
      attachmentsService.fromContract(id).then(res => {
        this.attachments_contract = res.data
        this.attachment_details.parent_id.options = res.data.map(attachment => {
          return { value: attachment.id, text: 'Anexo ' + attachment.attachment_id + ' ' + (attachment.amount).toFixed(2) }
        })
      })

      this.attachment_details.cut_day.value = {
        value: newContract.cut_day,
        text: newContract.cut_day
      }

      this.attachment_details.interest_rate.value = newContract.interest_rate

      this.attachment_details.frequency.value = {
        value: newContract.frequency,
        text: newContract.frequency
      }
    },

    'attachment_details.parent_id.value': function (newAttachment, oldAttachment) {
      let attachmentSelected = null
      let attachments = this.attachments_contract
      if (attachments) {
        Object.keys(attachments).forEach(function (attachment) {
          if (newAttachment.value == attachments[attachment].id) {
            attachmentSelected = attachments[attachment]
          }
        })
      }

      if (!attachmentSelected) {
        this.attachment_details.date_init.value = ''
        this.attachment_details.amount.value = ''
        return
      }

      this.attachment_details.date_init.value = moment().format('YYYY-MM-DD')

      this.attachment_details.amount.value = attachmentSelected.amount
    }
  }
}
</script>

<style lang="scss" scoped>
.font-info {
  font-size: 1.5rem;
  color: var(--primary);
}
</style>



// WEBPACK FOOTER //
// src/components/attachments/AttachmentCreate.vue